import * as Swiper from 'swiper';
import { BindSwiperGalleryQuote, WireGalleryQuoteModal } from '../gallery-quote-modal';

main();

function main() {
    const $main = document.querySelector('main.types-uses-page') as HTMLElement;
    const lineItem = $main?.dataset.lineItem || 'Lapel Pin';
    const pageTitle = $main?.dataset.pageTitle || lineItem;
    const minQty = parseInt($main?.dataset.minQty || '100', 10);

    bindBannerThumbs();

    new Swiper.Swiper('.swiper:not(.banner-thumbs-swiper)', {
        autoplay: true,
        loop: true,
        slidesPerView: 'auto',
        spaceBetween: 8,
        pagination: {
            el: '.swiper-pagination',
        },
        scrollbar: {
            el: '.swiper-scrollbar',
        },
    });

    BindSwiperGalleryQuote(({ $body, $link, $img }) => {
        WireGalleryQuoteModal($body, {
            lineItem: lineItem,
            minQty: minQty,
            formName: `${pageTitle} gallery`,
            productLabel: lineItem,
            notesIntro: `something like this from your "${pageTitle}" gallery`,
            imageSrc: $img.src,
            reopen: () => $link.click(),
        });
    });

    function bindBannerThumbs() {
        const $thumbs = Array.from(document.querySelectorAll<HTMLButtonElement>('[data-banner-thumb]'));
        if ($thumbs.length < 2) {
            return;
        }

        const $images = Array.from(document.querySelectorAll<HTMLElement>('.banner-img'));
        const $banner = document.querySelector<HTMLElement>('.banner');

        let bannerSwiper: Swiper.Swiper | undefined;

        // Matches the .banner-img opacity transition in types-uses.scss.
        const crossfadeMs = 400;
        // The replaced copy keeps `active` until its fade ends, so `active` can't tell you
        // which one is displayed.
        let currentIndex = $images.find($img => $img.classList.contains('active'))?.dataset.bannerIndex ?? '0';
        let $outgoing: HTMLElement[] = [];
        let settleTimer: number | undefined;

        // Drop the copies the fade replaced; they stay opaque under the incoming one until
        // now, so the layer never goes partly transparent. Instant rather than a fade: one
        // still animating after the swap looks done reads as a second transition.
        const settle = () => {
            for (const $img of $outgoing) {
                $img.classList.add('banner-img-settle');
                $img.classList.remove('active');
            }
            // Commit with transitions off, then hand them back.
            document.body.getBoundingClientRect();
            for (const $img of $outgoing) {
                $img.classList.remove('banner-img-settle');
            }
            $outgoing = [];
            settleTimer = undefined;
        };

        const activate = (index: string) => {
            const $incoming = $images.filter($img => $img.dataset.bannerIndex === index);
            // Ignore clicks mid-fade: interrupting means jumping the half-faded copy to opaque
            // to serve as the next one's base, and that jump always showed.
            if (!$incoming.length || index === currentIndex || settleTimer !== undefined) {
                return;
            }
            currentIndex = index;

            $outgoing = $images.filter($img => $img.classList.contains('active'));
            for (const $img of $outgoing) {
                $img.classList.remove('banner-img-top');
            }
            for (const $img of $incoming) {
                $img.classList.add('banner-img-top', 'active');
            }
            const bannerBg = $incoming[0].dataset.bannerBg;
            if (bannerBg && $banner) {
                $banner.style.setProperty('--banner-bg', bannerBg);
            }
            settleTimer = window.setTimeout(settle, crossfadeMs);

            for (const $thumb of $thumbs) {
                $thumb.classList.toggle('active', $thumb.dataset.bannerThumb === index);
            }
            bannerSwiper?.slideTo(Number(index));
        };

        for (const $thumb of $thumbs) {
            const index = $thumb.dataset.bannerThumb ?? '';
            $thumb.addEventListener('click', () => activate(index));
        }

        const $swiper = document.querySelector<HTMLElement>('.banner-thumbs-swiper');
        const $wrap = $swiper?.closest('.banner-thumbs-swiper-wrap');
        if ($swiper && $wrap) {
            // Defer init until the page has fully loaded: Swiper measures slide
            // positions once at init, and on an uncached load it can run before
            // the layout settles, leaving the selected thumbnail clipped off the
            // edge. Before init the slides simply render flush-left, which reads
            // fine while assets finish loading.
            const initBannerSwiper = () => {
                bannerSwiper = new Swiper.Swiper($swiper, {
                    slidesPerView: 'auto',
                    spaceBetween: 12,
                    // Center the selected thumbnail, but keep the strip flush at
                    // the ends (no blank padding) rather than looping — Swiper
                    // can't loop this few slides while six are visible.
                    centeredSlides: true,
                    centeredSlidesBounds: true,
                    watchOverflow: true,
                });
                $wrap.classList.remove('banner-thumbs-loading');
            };

            if (document.readyState === 'complete') {
                initBannerSwiper();
            } else {
                window.addEventListener('load', initBannerSwiper, { once: true });
            }
        }
    }
}
